<!-- Partnership Benefits Section -->
<section class="flex flex-col items-center gap-12">
  <app-section-header
    icon="@tui.star"
    subtitle="Partnership Benefits"
    title="Why Choose OpenForge?"
    description="OpenForge brings 10+ years of mobile development expertise combined with intimate knowledge of the Capawesome ecosystem"
  />

  <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
    <!-- Capawesome Expertise -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.circle-check" class="mr-2" />
        <h3 class="text-xl font-bold">Capawesome Plugin Mastery</h3>
      </div>
      <p class="text-pretty text-lg">
        Deep familiarity with all Capawesome plugins and best practices for
        implementation in production environments
      </p>
    </div>

    <!-- Cloud Integration -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.cloud-download" class="mr-2" />
        <h3 class="text-xl font-bold">Capawesome Cloud Expert</h3>
      </div>
      <p class="text-pretty text-lg">
        Specialized knowledge in implementing and optimizing Capawesome Cloud
        for over-the-air updates at enterprise scale
      </p>
    </div>

    <!-- Enterprise Experience -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.building" class="mr-2" />
        <h3 class="text-xl font-bold">Enterprise-Grade Development</h3>
      </div>
      <p class="text-pretty text-lg">
        Proven track record delivering scalable mobile solutions for enterprise
        clients with complex requirements
      </p>
    </div>

    <!-- Cross-Platform Expertise -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.smartphone" class="mr-2" />
        <h3 class="text-xl font-bold">Cross-Platform Mastery</h3>
      </div>
      <p class="text-pretty text-lg">
        Expert development across iOS, Android, and web platforms using Ionic,
        React, Flutter, and modern frameworks
      </p>
    </div>

    <!-- Industry Specialization -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.zap" class="mr-2" />
        <h3 class="text-xl font-bold">Industry Specialization</h3>
      </div>
      <p class="text-pretty text-lg">
        Deep expertise across healthcare, AI, logistics, EdTech, and consumer
        applications with industry-specific knowledge
      </p>
    </div>

    <!-- Accelerated Development -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.clock" class="mr-2" />
        <h3 class="text-xl font-bold">Accelerated Timeline</h3>
      </div>
      <p class="text-pretty text-lg">
        Proven ability to deliver mobile applications 30% faster than industry
        standards through optimized development processes
      </p>
    </div>
  </div>
</section>
